import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewProtocolo = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'protocolo',
        name: 'Protocolo',
        component: ViewProtocolo,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
